module.exports = __webpack_public_path__ + "01ea978f/img/menu-icon.5f8facae.svg";